import { render, staticRenderFns } from "./ContractRecirdComponent.vue?vue&type=template&id=f1c275b8"
import script from "./ContractRecirdComponent.vue?vue&type=script&lang=js"
export * from "./ContractRecirdComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports